import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Table, Text } from '@eneco/sparky';
import { wrap } from '@sitecore/common';
import { SimpleTableRendering } from '@sitecore/types/manual/SimpleTable';

const SimpleTable: FC<SimpleTableRendering> = ({ fields }) => {
  if (fields.content?.title?.editable && !fields.content?.title?.value) fields.content.title.value = 'title';
  return (
    <Table title={wrap(fields.content.title)}>
      {fields.content.propertiesList.map(property => (
        <Table.Row key={property.id}>
          <Text>{wrap(property.fields.content.label, <RichText html={property.fields.content.label.value} />)}</Text>
          <Text>{wrap(property.fields.content.label, <RichText html={property.fields.content.text.value} />)}</Text>
        </Table.Row>
      ))}
    </Table>
  );
};
export { SimpleTable };
export default SimpleTable;
